var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import { SvgCircleIcon } from '../elements/svg-circle-icon';
export var RestorationMetricIcon = function (props) {
  return React.createElement(SvgCircleIcon, __assign({}, props, {
    glyphWidth: 70,
    glyphHeight: 48
  }), React.createElement("path", {
    d: "M0 0H56V2V4V8.12529C63.8652 9.11726 70 15.877 70 24C70 32.123 63.8652 38.8827 56 39.8747V44V46V48H0V44H8V34H12V44H20V34H24V44H32V34H36V44H52V39.8747C44.1348 38.8827 38 32.123 38 24C38 15.877 44.1348 9.11726 52 8.12529V4H36V14H32V4H24V14H20V4H12V14H8V4H0V0ZM13 20.6C12 20.6 11.2 21 10.6 21.6V17H8V30.2H10.6V24C10.6 23.2 11.4 22.8 12.2 22.8C12.8 22.8 13.4 23 13.4 24.4V30H16V24.2C16 22 15 20.6 13 20.6ZM26.8 28V24C26.8 21.8 25.4 20.6 22.8 20.6C21 20.6 19.8 21.2 19.2 22.4L19 22.6L20.6 24L20.8 23.8C21.2 23 21.8 22.8 22.6 22.8C23.6 22.8 24 23.2 24 24.2V24.6H22.8C20.2 24.6 18.8 25.6 18.8 27.6C18.8 29.4 20 30.4 21.8 30.4C23 30.4 24 30 24.4 29C24.6 29.8 25.4 30.2 26.2 30.2H27.6V28H26.8ZM22.6 28.4C21.4 28.4 21.4 27.8 21.4 27.6V27.4C21.4 26.8 21.8 26.6 22.8 26.6H24V27.6C24 28 23.2 28.4 22.6 28.4ZM42.4 24.8L50.4 32.8L63.6 19.6L61 17L50.4 27.6L45 22.2L42.4 24.8Z"
  }));
};
export var RestorationMetricIconGlyph = function (props) {
  return React.createElement(RestorationMetricIcon, __assign({}, props, {
    variant: 'glyph'
  }));
};